module.exports = __webpack_public_path__ + "img/logistics-trajectory-process.929f9472.svg";